import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { baseUrl } from 'Utils/envLoader';

import { Link } from 'react-router-dom';
import { Table, Breadcrumb } from 'react-bootstrap';
import { AiOutlinePlusCircle } from 'react-icons/ai';

const Apps = () => {
    const [projets, setProjets] = useState([]);

    useEffect(() => {
        axios
            .get(`${baseUrl}/cliami/projets`)
            .then((result) => {
                if (result.status === 200) {
                    setProjets(result.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item>
                    <Link to="/">Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to="/admin">Admin</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Projets</Breadcrumb.Item>
            </Breadcrumb>
            <div className="d-flex justify-content-between align-items-center py-2">
                <h2>Projets</h2>
                <Link to="/admin/projet/create">
                    <button className="btn btn-outline-primary btn-sm">
                        <AiOutlinePlusCircle></AiOutlinePlusCircle>
                        <span className="ml-1">New</span>
                    </button>
                </Link>
            </div>

            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {projets.length ? (
                        projets.map((projet, key) => {
                            return (
                                <tr key={key}>
                                    <td>{projet.name}</td>
                                    <td>{projet.description}</td>
                                    <td>
                                        <Link to={`/admin/projet/edit/${projet.projetId}`}>
                                            <img
                                                src="/images/edit.svg"
                                                alt=""
                                                style={{
                                                    height: '15pt',
                                                }}
                                            />
                                        </Link>
                                    </td>
                                    <td>
                                        {/* <Link to={`/admin/projet/delete/${projet.projetId}`}>
                                            <img
                                                src="/images/delete.svg"
                                                alt=""
                                                style={{
                                                    height: '18pt',
                                                }}
                                            />
                                        </Link> */}
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="4">no data</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </>
    );
};

export default Apps;
